import { ClickToComponent as Component } from './ClickToComponent.js';
export var ClickToComponent = process.env.NODE_ENV === 'development' ? Component : function () {
  return null;
};